export default __webpack_public_path__ + "static/media/6.676f0e14.png";